import secureLocalStorage from "react-secure-storage";
import { resetSelections } from "../Redux/filterSlice";

export const resetFilterState = (dispatch, options = {}) => {
  const { skipReload = false } = options;
  sessionStorage.clear();
  secureLocalStorage.removeItem("IsPastSearch");
  secureLocalStorage.removeItem("filter-selections");
  dispatch(resetSelections());

  if (skipReload) return;
  if (window.location.pathname.includes("pastSearch")) {
    const url = new URL(window.location.href);
    const cleanedPath = url.pathname.replace(/\/?pastSearch\/?/, "/");
    url.pathname = cleanedPath.replace(/\/{2,}/g, "/");
    window.location.href = url.toString();
  } else {
    window.location.reload();
  }
};
